import { createWebHistory, createRouter } from 'vue-router'

import { EmptyLayout, NotFound } from '@azimut-mfe/styleguide'

const ViewLogin = () => import('@/views/Login')
const ViewLogout = () => import('@/views/Logout')
const ViewRefreshSession = () => import('@/views/RefreshSession')
const ViewForgotPassword = () => import('@/views/ForgotPassword')
const ViewResetPassword = () => import('@/views/ResetPassword')
const ViewNewPassword = () => import('@/views/NewPassword')
const ViewExecuteRedirectToExternalLink = () =>
  import('@/views/ExecuteRedirectToExternalLink')
const ViewExecuteExternalAuth = () => import('@/views/ExecuteExternalAuth')
const ViewExecuteCheckCrossAuth = () => import('@/views/ExecuteCheckCrossAuth')

export const whiteList = [
  '/auth/login',
  '/auth/logout',
  '/auth/refresh-session',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/external-auth',
  '/auth/new-password',
  '/auth/redirect-to-external-link',
  '/auth/check-cross-auth',
]

export const constantRoutes = [
  {
    path: '',
    redirect: '/auth/login',
  },
  {
    path: 'login',
    component: ViewLogin,
    name: 'Login',
  },
  {
    path: 'logout',
    component: ViewLogout,
  },
  {
    path: 'refresh-session',
    component: ViewRefreshSession,
  },
  {
    path: 'forgot-password',
    component: ViewForgotPassword,
  },
  {
    path: 'reset-password',
    component: ViewResetPassword,
  },
  {
    path: 'external-auth',
    component: ViewExecuteExternalAuth,
  },
  {
    path: 'new-password',
    component: ViewNewPassword,
  },
  {
    path: 'redirect-to-external-link',
    component: ViewExecuteRedirectToExternalLink,
  },
  {
    path: 'check-cross-auth',
    component: ViewExecuteCheckCrossAuth,
  },
]

const routes = [
  {
    path: '/auth',
    name: 'auth',
    component: EmptyLayout,
    children: constantRoutes,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: EmptyLayout,
    children: [
      {
        path: '',
        component: NotFound,
        meta: {
          permissions: '*',
        },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
